import { motion, useReducedMotion } from 'framer-motion'

export function RealitySection() {
  const reduceMotion = useReducedMotion()

  return (
    <section className="relative bg-charcoal-black px-6 py-20 md:py-28">
      <motion.div
        className="mx-auto max-w-3xl text-center"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{
          duration: reduceMotion ? 0.6 : 0.7,
          ease: 'easeOut',
        }}
      >
        <p className="inline-flex items-center gap-2 rounded-full border border-forest-green/25 bg-forest-green/[0.06] px-3 py-1 text-[11px] font-medium uppercase tracking-[0.18em] text-forest-green/90">
          The honest part
        </p>
        <h2 className="mt-4 text-[2.15rem] font-semibold leading-[1.08] tracking-tight text-soft-white md:text-5xl">
          {"You're not bad at this."}
        </h2>
        <p className="mx-auto mt-6 max-w-[56ch] text-lg leading-relaxed text-muted-silver">
          Most apps hand you a generic plan, ignore your bad week, and make you feel like a failure
          when you fall behind.
        </p>
        <p className="mx-auto mt-4 max-w-[56ch] text-lg leading-relaxed text-muted-silver">
          {
            "Boomshift was built differently — because what actually keeps people going isn't another streak counter. It's having someone in your corner who actually sees your data."
          }
        </p>
      </motion.div>
    </section>
  )
}
